/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { breakpoints } from '@coursera/cds-core';

import Section from 'bundles/front-page/components/Section';
import OverflowCarousel from 'bundles/front-page/components/overflow-carousel/OverflowCarousel';
import DomainPill from 'bundles/front-page/redesign-modules/domains/DomainPill';
import getDomainData from 'bundles/front-page/redesign-modules/domains/getDomainData';

import _t from 'i18n!nls/front-page';

const styles = {
  pills: css`
    display: flex;
    gap: var(--cds-spacing-100);
    flex-wrap: wrap;

    ${breakpoints.down('sm')} {
      flex-wrap: nowrap;
    }
  `,
};

const DomainsModuleRenderer = () => {
  const domains = getDomainData();

  return (
    <Section title={_t('Explore categories')}>
      <OverflowCarousel css={styles.pills} shouldAllowSpaceForHoverItems>
        {domains.map((domain) => (
          <DomainPill key={domain.id} {...domain} />
        ))}
      </OverflowCarousel>
    </Section>
  );
};

export default DomainsModuleRenderer;
